import { Outlet, Route } from 'react-router-dom';
import ProtectedHOC from 'src/components/ProtectedHOC';
import WorkspaceSettings from 'src/pages/Organization/Workspace/Settings';
import ManageJournals from 'src/pages/Organization/Workspace/Settings/Journals';
import ManageJournal from 'src/pages/Organization/Workspace/Settings/Journals/[id]';
import ConfigureJournal from 'src/pages/Organization/Workspace/Settings/Journals/[id]/Configure';
import Members from 'src/pages/Organization/Workspace/Settings/Members';
import Roles from 'src/pages/Organization/Workspace/Settings/Roles';
import ManageTagTabs from 'src/pages/Organization/Workspace/Settings/ManageTags';
import CreateRole from 'src/pages/Organization/Workspace/Settings/Roles/Create';
import ArticleTypes from 'src/pages/Organization/Workspace/Settings/ArticleTypes';
import CreateJournalArticleTypes from 'src/pages/Organization/Workspace/Settings/Journals/[id]/CreateJournalArticleTypes';
import ManageEmails from 'src/pages/Organization/Workspace/Settings/Emails';
import VendorExport from 'src/pages/Organization/Workspace/Settings/VendorExports';
import Reports from 'src/pages/Organization/Workspace/Settings/Reports';
import Analytics from 'src/pages/Organization/Workspace/Settings/Analytics';

const ManageWorkspaceRoutes = (
  <Route
    path="manage"
    element={
      <ProtectedHOC
        relation={['canManage', 'canView']}
        entityType="workspace"
        entityKey="shortname"
      >
        <Outlet />
      </ProtectedHOC>
    }
  >
    <Route
      index
      element={
        <ProtectedHOC
          relation="canManage"
          entityType="workspace"
          entityKey="shortname"
        >
          <WorkspaceSettings />
        </ProtectedHOC>
      }
    />
    <Route
      path="roles"
      element={
        <ProtectedHOC
          relation="canManage"
          entityType="workspace"
          entityKey="shortname"
        >
          <Outlet />
        </ProtectedHOC>
      }
    >
      <Route index element={<Roles />} />
    </Route>
    <Route
      path="article-types"
      element={
        <ProtectedHOC
          relation="canManage"
          entityType="workspace"
          entityKey="shortname"
        >
          <Outlet />
        </ProtectedHOC>
      }
    >
      <Route index element={<ArticleTypes />} />
    </Route>
    <Route
      path="vendor-exports"
      element={
        <ProtectedHOC
          relation="canManage"
          entityType="workspace"
          entityKey="shortname"
        >
          <Outlet />
        </ProtectedHOC>
      }
    >
      <Route index element={<VendorExport />} />
    </Route>
    <Route
      path="reports"
      element={
        <ProtectedHOC
          relation={['canManage', 'canView']}
          entityType="workspace"
          entityKey="shortname"
        >
          <Outlet />
        </ProtectedHOC>
      }
    >
      <Route index element={<Reports />} />
    </Route>
    <Route
      path="analytics"
      element={
        <ProtectedHOC
          relation={['canManage', 'canView']}
          entityType="workspace"
          entityKey="shortname"
        >
          <Outlet />
        </ProtectedHOC>
      }
    >
      <Route index element={<Analytics />} />
    </Route>
    <Route
      path="roles/create"
      element={
        <ProtectedHOC
          relation="role_manager"
          entityType="workspace"
          entityKey="shortname"
        >
          <Outlet />
        </ProtectedHOC>
      }
    >
      <Route index element={<CreateRole />} />
    </Route>

    {/* ----- Journals ----- */}
    <Route
      path="journals"
      element={
        <ProtectedHOC
          relation="canManage"
          entityType="workspace"
          entityKey="shortname"
        >
          <Outlet />
        </ProtectedHOC>
      }
    >
      <Route index element={<ManageJournals />} />
      <Route path="create" element={<div />} />
      <Route path=":journalId" element={<Outlet />}>
        <Route index element={<ManageJournal />} />
        <Route path="edit" element={<ConfigureJournal />} />
        <Route path="article-types" element={<Outlet />}>
          <Route path="create" element={<CreateJournalArticleTypes />} />
        </Route>
      </Route>
    </Route>

    {/* ----- User ----- */}
    <Route
      path="user"
      element={
        <ProtectedHOC
          relation={['team_manager', 'canView']}
          entityType="workspace"
          entityKey="shortname"
        >
          <Members />
        </ProtectedHOC>
      }
    />
    {/* ----- Tags ----- */}
    <Route
      path="tags"
      element={
        <ProtectedHOC
          relation="canManage"
          entityType="workspace"
          entityKey="shortname"
        >
          <ManageTagTabs />
        </ProtectedHOC>
      }
    />
    {/* ----- Emails ----- */}
    <Route
      path="emails"
      element={
        <ProtectedHOC
          relation={['team_manager', 'canView']}
          entityType="workspace"
          entityKey="shortname"
        >
          <ManageEmails />
        </ProtectedHOC>
      }
    >
      <Route path=":emailTab" element={null} />
    </Route>
  </Route>
);

export default ManageWorkspaceRoutes;
